const droplist = {
	elem: {
		droplist: document.querySelectorAll('.droplist .br-toggle')
	},
	mql: {
		large: window.matchMedia('(min-width: 768px)')
	},
	initialized: false,
	init() {
		droplist.toggle();
		droplist.mql.large.addListener(droplist.toggle);
	},
	// toggle the display of the droplist on larger screens
	toggle() {
		if (droplist.mql.large.matches) {			
			// Destroy Droplist
			if (droplist.initialized) {
				
				droplist.elem.droplist.forEach( function( element ) {
					element.toggle.destroy();
				});

				droplist.initialized = false
			}

		} else {
			// Create Droplist			
			if (droplist.elem.droplist.length > 0) {			
				
				droplist.elem.droplist.forEach( function( element ) {
					element.toggle = Object.assign(new BRToggle(element, { accordion: false }));
				});

				droplist.initialized = true
			}
		}
	},
};

export { droplist };
